import 'src/index.scss';
import { BrowserRouter } from 'react-router-dom';
import arbManifest from 'translations/arbManifest';

import { MbmProvider } from '@amzn/react-arb-tools';
import { LoggerProvider, ModalProvider, ModalWrapper } from '@amzn/sss-website-theme';

import { SssApiCreditsClientProvider, AcpsCreditsClientProvider } from 'src/clients';
import { ErrorBoundary } from 'src/components/common/error';
import { getMbmOptions } from 'src/helpers/translations/translation-helpers';
import { asxLogger } from 'src/logger';

import { PageRoutes } from './PageRoutes';

const mbmOptions = getMbmOptions(arbManifest);

export const App = () => (
  <MbmProvider {...mbmOptions}>
    <LoggerProvider value={asxLogger}>
      <ErrorBoundary>
        <SssApiCreditsClientProvider>
          <AcpsCreditsClientProvider>
            <ModalProvider>
              <div className="ash-theme rebranding">
                <BrowserRouter>
                  <PageRoutes />
                  <ModalWrapper />
                </BrowserRouter>
              </div>
            </ModalProvider>
          </AcpsCreditsClientProvider>
        </SssApiCreditsClientProvider>
      </ErrorBoundary>
    </LoggerProvider>
  </MbmProvider>
);
